import { render, staticRenderFns } from "./SensorAlerts.html?vue&type=template&id=6773536c&scoped=true&external"
import script from "./SensorAlerts.vue?vue&type=script&lang=js"
export * from "./SensorAlerts.vue?vue&type=script&lang=js"
import style0 from "./SensorAlerts.scss?vue&type=style&index=0&id=6773536c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6773536c",
  null
  
)

export default component.exports